import { render, staticRenderFns } from "./InclusiveGroupItemConfig.vue?vue&type=template&id=6f4149ad&scoped=true"
import script from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveGroupItemConfig.vue?vue&type=style&index=0&id=6f4149ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4149ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4149ad')) {
      api.createRecord('6f4149ad', component.options)
    } else {
      api.reload('6f4149ad', component.options)
    }
    module.hot.accept("./InclusiveGroupItemConfig.vue?vue&type=template&id=6f4149ad&scoped=true", function () {
      api.rerender('6f4149ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/config/InclusiveGroupItemConfig.vue"
export default component.exports